import { render, staticRenderFns } from "./KpiSchemeSetting.vue?vue&type=template&id=5e8f7d78&scoped=true"
import script from "./KpiSchemeSetting.vue?vue&type=script&lang=ts"
export * from "./KpiSchemeSetting.vue?vue&type=script&lang=ts"
import style0 from "./KpiSchemeSetting.vue?vue&type=style&index=0&id=5e8f7d78&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f7d78",
  null
  
)

export default component.exports